import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/publication.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import TabList from '@/components/common/Tab/TabList/TabList';
import PublicationAdvertisementGuide from '@/components/Publication/PublicationAdvertisementGuide/PublicationAdvertisementGuide';
import PublicationArticlePayment from '@/components/Publication/PublicationArticlePayment/PublicationArticlePayment';
import PublicationConfirm from '@/components/Publication/PublicationConfirm/PublicationConfirm';
import PublicationJournalGuide from '@/components/Publication/PublicationJournalGuide/PublicationJournalGuide';
import PublicationJournalSearch from '@/components/Publication/PublicationJournalSearch/PublicationJournalSearch';
import {
	normalizePublicationMenu,
	normalizePublicationStep,
	PUBLICATION_MENU_ADVERTISEMENT,
	PUBLICATION_MENU_ARTICLE_PAYMENT,
	PUBLICATION_MENU_RULES,
	PUBLICATION_MENU_SEARCH,
	PUBLICATION_STEP_CONFIRM,
} from '@/constants/publication';

const menuList = [PUBLICATION_MENU_SEARCH, PUBLICATION_MENU_RULES];

const Publication = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const params = normalizePublicationMenu(location.state?.menu);
	const stepParams = normalizePublicationStep(location.state?.step);

	const handleSetMenu = (menu: string) => {
		navigate('/publication', { state: { menu: menu } });
	};

	return (
		<main>
			<SubBanner subTitle="publication.page.bannerSubtitle" title="publication.page.bannerTitle" img={mainBanner} />
			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === PUBLICATION_MENU_SEARCH && <PublicationJournalSearch />}
			{params === PUBLICATION_MENU_RULES && <PublicationJournalGuide />}
			{params === PUBLICATION_MENU_ARTICLE_PAYMENT && stepParams !== PUBLICATION_STEP_CONFIRM && <PublicationArticlePayment />}
			{params === PUBLICATION_MENU_ARTICLE_PAYMENT && stepParams === PUBLICATION_STEP_CONFIRM && <PublicationConfirm />}
			{params === PUBLICATION_MENU_ADVERTISEMENT && <PublicationAdvertisementGuide />}
		</main>
	);
};

export default Publication;
